import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);
const routes = [
  {
    path: "/",
    name: "Home",
    component: () =>
      import(/* webpackChunkName: "Devices" */ "../views/Devices"),
    meta: {
      preName: "devices",
      layout: "MainLayout",
      requiredAuth: true,
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () =>
      import(/* webpackChunkName: "Register" */ "../views/Register"),
    meta: {
      layout: "AuthLayout",
      requiredAuth: false,
    },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () =>
      import(
        /* webpackChunkName: "ForgotPassword" */ "../views/ForgotPassword"
      ),
    meta: {
      layout: "AuthLayout",
      requiredAuth: false,
    },
  },
  {
    path: "/forgot-password/create-new-password",
    name: "createNewPassword",
    component: () =>
      import(
        /* webpackChunkName: "createNewPassword" */ "../views/ForgotPassword/createNewPassword"
      ),
    meta: {
      layout: "AuthLayout",
      requiredAuth: false,
    },
  },
  {
    path: "/forgot-password/request-sended",
    name: "requestSended",
    component: () =>
      import(
        /* webpackChunkName: "requestSended" */ "../views/ForgotPassword/requestSended"
      ),
    meta: {
      layout: "AuthLayout",
      requiredAuth: false,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: () => import(/* webpackChunkName: "Login" */ "../views/Login"),
    meta: {
      layout: null,
      requiredAuth: false,
    },
  },
  {
    path: "/devices",
    name: "Devices",
    component: () =>
      import(/* webpackChunkName: "Devices" */ "../views/Devices"),
    meta: {
      preName: "devices",
      layout: "MainLayout",
      requiredAuth: true,
    },
  },
  {
    path: "/change-password",
    name: "ChangePassword",
    component: () =>
      import(/* webpackChunkName: "Device" */ "../views/ChangePassword"),
    meta: {
      layout: "MainLayout",
      requiredAuth: true,
    },
  },
  {
    path: "/applications",
    name: "ApplicationsPage",
    component: () =>
      import(/* webpackChunkName: "Device" */ "../views/ApplicationsPage"),
    meta: {
      preName: "apps",
      layout: "MainLayout",
      requiredAuth: true,
    },
  },
  {
    path: "/my-profile",
    name: "MyProfile",
    component: () =>
      import(/* webpackChunkName: "MyProfile" */ "../views/MyProfile"),
    meta: {
      layout: "MainLayout",
      requiredAuth: true,
    },
  },
  {
    path: "/android-launcher/:deviceId",
    name: "DeviceLauncherAndroid",
    component: () =>
      import(
        /* webpackChunkName: "DeviceLauncher" */ "../views/DeviceLauncher/android"
      ),
    meta: {
      preName: "deviceLauncherAndroid",
      layout: "LaunchDeviceLayout",
      requiredAuth: false,
    },
  },
  {
    path: "/ios-launcher/:deviceId",
    name: "DeviceLauncherIos",
    component: () =>
      import(
        /* webpackChunkName: "DeviceLauncher" */ "../views/DeviceLauncher/ios"
      ),
    meta: {
      preName: "deviceLauncherIos",
      layout: "LaunchDeviceLayout",
      requiredAuth: false,
    },
  },
  {
    path: "/ios-launcher-new/:deviceId",
    name: "DeviceLauncherNewIos",
    component: () =>
      import(
        /* webpackChunkName: "DeviceLauncher" */ "../views/DeviceLauncher/new-ios"
      ),
    meta: {
      preName: "deviceLauncherNewIos",
      layout: "LaunchDeviceLayout",
      requiredAuth: false,
    },
  },
  {
    path: "/pricing",
    name: "Pricing",
    component: () =>
      import(/* webpackChunkName: "Pricing" */ "../views/Pricing"),
    meta: {
      preName: "pricing",
      layout: "MainLayout",
      requiredAuth: true,
    },
  },
  {
    path: "/preferences",
    name: "Preferences",
    component: () =>
      import(/* webpackChunkName: "Preferences" */ "../views/Preferences"),
    meta: {
      layout: "MainLayout",
      requiredAuth: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const { isNavigationFailure, NavigationFailureType } = VueRouter;

router.beforeEach((to, from, next) => {
  store.dispatch("emitMixPanelEvent", {
    event: "mlView",
    data: {
      page: to.name,
    },
  });
  if (to.matched.some((record) => record.meta.requiredAuth)) {
    if (localStorage.getItem("access_token") != null) {
      next();
    } else {
      router
        .push({
          name: "Login",
          params: { nextUrl: to.fullPath },
        })
        .catch((e) => {
          if (!isNavigationFailure(e, NavigationFailureType.redirected)) {
            Promise.reject(e);
          }
        });
    }
  } else {
    next();
  }
});

export default router;
